const pallete = [
	'#f1eef6',
	'#dd1c77',
	'#df65b0',
	'#d7b5d8',
	'#980043',
];

export default pallete;
